import { ColorModel } from "./color.model";

export class BrandModel {
  banner: string;
  logo: string;
  icon: string;
  title: string;
  subtitle: string;
  colors: ColorModel;

  constructor(obj: any = null) {
    this.banner = obj?.banner
    this.logo = obj?.logo
    this.icon = obj?.icon
    this.title = obj?.title
    this.subtitle = obj?.subtitle
    this.colors = new  ColorModel(obj?.colors)
  }
}
